import { isCNRegion } from '@eureka/utils/environment';

/**
 * 动态插入 Google Tag Manager 脚本
 * 应在 DOM 挂载后调用
 *
 * 此函数会在页面的 head 和 body 中插入 GTM 所需的脚本和标签：
 * 1. 在 <head> 中尽可能靠前的位置插入 GTM 主脚本
 * 2. 在 <body> 开始标签后插入 noscript iframe（用于禁用 JavaScript 时的跟踪）
 *
 * 注意：仅在非 CN region 时执行（即 !isCNRegion()）
 */
export function insertGoogleTagManager(): void {
    // 只在非 CN region 时插入 GTM 脚本
    if (isCNRegion()) {
        console.debug('[GTM] Skipped: CN region detected');
        return;
    }

    const GTM_ID = 'GTM-5HTSKLTM';

    try {
        // 1. 插入 GTM 主脚本到 head
        const headScript = document.createElement('script');
        headScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`;

        // 插入到 head 的第一个位置
        const headFirstChild = document.head.firstChild;
        if (headFirstChild) {
            document.head.insertBefore(headScript, headFirstChild);
        } else {
            document.head.appendChild(headScript);
        }

        console.debug('[GTM] GTM script inserted into <head>');

        // 2. 插入 noscript iframe 到 body 开始位置
        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);

        // 插入到 body 的第一个位置
        const bodyFirstChild = document.body.firstChild;
        if (bodyFirstChild) {
            document.body.insertBefore(noscript, bodyFirstChild);
        } else {
            document.body.appendChild(noscript);
        }

        console.debug('[GTM] GTM noscript inserted into <body>');
    } catch (error) {
        console.error('[GTM] Failed to insert Google Tag Manager scripts:', error);
    }
}
